import {createReducer} from 'redux-act';
import {MapPageData} from '@/app/interfaces/map';
import {fetchMapsDataAction} from './actions';

const initialState = {
	data: null as null | MapPageData,
};

export const mapsReducer = createReducer({}, initialState);

mapsReducer.on(fetchMapsDataAction.success, (state, data) => ({
	...state,
	data,
}));
